import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import { keyCode } from '@bingads-webui/keycode';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';

import templateVNext from './template-vnext.pug';
import { AddCardViewModel } from './viewmodel';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/dashboard-page');
const permissions = config.get('Permissions') || {};

/* @this AddCardView */
function saveAddCard() {
  this.trigger('apply', {
    idsToAdd: this.viewModel.cardsToAdd(),
    idsToDelete: this.viewModel.cardsToDelete(),
  });
}

/* @this AddCardView */
function cancelAddCard() {
  this.trigger('cancel');
}

/* @this GetNextFocusedIndex */
function getNextFocusedItemIndex(numOfCards, previousIndex, isNext) {
  const maxIndex = numOfCards - 1;

  let newIndex;

  if (previousIndex < 0) {
    newIndex = 0;
  } else if (previousIndex > maxIndex) {
    newIndex = maxIndex;
  } else if (isNext && previousIndex === maxIndex) {
    newIndex = 0;
  } else if (!isNext && previousIndex === 0) {
    newIndex = maxIndex;
  } else {
    newIndex = isNext ? previousIndex + 1 : previousIndex - 1;
  }

  return newIndex;
}

/* @this GetAllCardElements */
function getAllAvailableCardElements() {
  return this.$('.add-card__card-box');
}

/* @this AddCardKeyDown */
function onKeyDown(event) {
  const allAvailableCardElements = getAllAvailableCardElements.call(this);
  const numOfCards = allAvailableCardElements.length;
  if (numOfCards === 0) {
    return;
  }
  if (event.keyCode === keyCode.ArrowDown) {
    this.focusedIndex = getNextFocusedItemIndex(numOfCards, this.focusedIndex, true);
    event.preventDefault();
  } else if (event.keyCode === keyCode.ArrowUp) {
    this.focusedIndex = getNextFocusedItemIndex(numOfCards, this.focusedIndex, false);
    event.preventDefault();
  } else if (event.keyCode === keyCode.Home) {
    this.focusedIndex = 0;
  } else if (event.keyCode === keyCode.End) {
    this.focusedIndex = numOfCards - 1;
  }
  const cardElement = allAvailableCardElements[this.focusedIndex];
  cardElement.focus();
}

export class AddCardView extends Backbone.View {
  initialize({
    selectedCards = [],
    navigationLevel,
    accountsMode,
    newCardsConfig = null,
    campaignType,
    newI18n,
  }) {
    this.navigationLevel = navigationLevel;
    this.campaignType = campaignType;
    const cardsConfig = newCardsConfig({
      permissions,
      edm,
      accountsMode,
    });
    this.focusedIndex = -1;
    const updateFocusedIndex = (index) => {
      this.focusedIndex = index;
    };
    this.newI18n = newI18n;

    this.viewModel = new AddCardViewModel({
      allAvailableCards: _.chain(cardsConfig).filter(conf => cardsConfig.isValidForNavigationLevel(
        conf,
        this.navigationLevel,
        this.campaignType
      )).map((conf) => {
        const useNewI18n = conf.useNewI18n || false;
        return ({
          typeId: conf.typeId,
          name: conf.name,
          addCardTitle: useNewI18n ? newI18n.getString(conf.addCardTitleKey) : i18n.getString(conf.addCardTitleKey),
          cssKey: conf.cssKey,
          desc: useNewI18n ? newI18n.getString(conf.descKey) : i18n.getString(conf.descKey),
        });
      }).value(),
      selectedCards,
      i18n,
      newI18n,
      updateFocusedIndex,
    });
  }

  events() {
    return {
      'click .save': saveAddCard,
      'click .cancel': cancelAddCard,
      'keydown .add-card__card-box': onKeyDown,
    };
  }

  render() {
    this.$el.html(templateVNext({
      i18n,
    }));
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  show() {
    this.$el.show();
  }

  hide() {
    this.$el.hide();
  }

  remove() {
    super.remove();
  }
}
